import * as types from "./inventories.actionTypes";
import { ErrorResponse } from "../../../interfaces/Response";
import { action, createAsyncAction } from "typesafe-actions";
import { createInventoryAsyncRequest, createInventoryAsyncResponse, getInventoryAsyncRequest, getInventoryAsyncResponse, selectInventoryAsyncRequest, selectInventoryAsyncResponse, updateInventoryAsyncRequest, updateInventoryAsyncResponse } from "./types";

export const resetState = () => action(types.RESET_STATE, {});

export const setError = (value: ErrorResponse) => action(types.SET_ERROR, { value });

export const getInventoryAsync = createAsyncAction(
  types.GET_INVENTORY_REQUEST,
  types.GET_INVENTORY_SUCCESS,
  types.GET_INVENTORY_FAILURE
)<getInventoryAsyncRequest, getInventoryAsyncResponse, ErrorResponse>();

export const updateInventoryAsync = createAsyncAction(
  types.UPDATE_INVENTORY_REQUEST,
  types.UPDATE_INVENTORY_SUCCESS,
  types.UPDATE_INVENTORY_FAILURE
)<updateInventoryAsyncRequest, updateInventoryAsyncResponse, ErrorResponse>();

export const createInventoryAsync = createAsyncAction(
  types.CREATE_INVENTORY_REQUEST,
  types.CREATE_INVENTORY_SUCCESS,
  types.CREATE_INVENTORY_FAILURE
)<createInventoryAsyncRequest, createInventoryAsyncResponse, ErrorResponse>();

export const selectInventoryAsync = createAsyncAction(
  types.SELECT_INVENTORY_REQUEST,
  types.SELECT_INVENTORY_SUCCESS,
  types.SELECT_INVENTORY_FAILURE
)<selectInventoryAsyncRequest, selectInventoryAsyncResponse, ErrorResponse>();